import { validate } from '@/utils/errors/helpers';
import { axios } from './axiosClient';
import type { VatCategory, VatLevel, VatFactor } from '@/types/Vat';
import { getVatCategoriesSchema } from '@/types/schemas/vat/getVatCategories';
import { getVatLevelsSchema } from '@/types/schemas/vat/vatLevelSchema';
import { getVatFactorsSchema } from '@/types/schemas/vat/vatFactorSchema';

export async function getVatCategories(): Promise<VatCategory[]> {
  const response = await axios.get('v2/vat/categories');
  return validate(getVatCategoriesSchema, response.data.data);
}

export async function removeVatCategoriesByIds(ids: string[]): Promise<string | null> {
  const response = await axios.post('/v2/vat/categories/delete-by-ids', ids, {
    validateStatus: (status: number) => status === 400 || status == 204,
  });

  if (response.status === 400)
    return response.data?.error?.code || response.data?.title || 'Unknown error occurred';
  else return null;
}

export async function addOrEditVatCategory(vatcategory: VatCategory) {
  const response = await axios.post('/v2/vat/categories', vatcategory);
  if (response.status === 201) return true;
  return false;
}

export async function getVatLevels(): Promise<VatLevel[]> {
  const response = await axios.get('v2/vat/levels');
  return validate(getVatLevelsSchema, response.data.data);
}

export async function removeVatLevelsByIds(ids: string[]): Promise<string | null> {
  const response = await axios.post('/v2/vat/levels/delete-by-ids', ids, {
    validateStatus: (status: number) => status === 400 || status == 204,
  });

  if (response.status === 400)
    return response.data?.error?.code || response.data?.title || 'Unknown error occurred';
  else return null;
}

export async function addOrEditVatLevel(vatlevel: VatLevel) {
  const response = await axios.post('/v2/vat/levels', vatlevel);
  if (response.status === 201) return true;
  return false;
}

export async function getVatFactors(): Promise<VatFactor[]> {
  const response = await axios.get('v2/vat/factors');
  return validate(getVatFactorsSchema, response.data.data);
}

export async function removeVatFactorsByIds(ids: string[]): Promise<string | null> {
  const response = await axios.post('/v2/vat/factors/delete-by-ids', ids, {
    validateStatus: (status: number) => status === 400 || status == 204,
  });

  if (response.status === 400)
    return response.data?.error?.code || response.data?.title || 'Unknown error occurred';
  else return null;
}

export async function addOrEditVatFactor(vatfactor: VatFactor) {
  const response = await axios.post('/v2/vat/factors', vatfactor);
  if (response.status === 201) return true;
  return false;
}
